import { oldProjectJobListPath, projectDetailsPath } from 'projects/routes/routePaths';
import {
  customerQuoteListPath,
  oldCustomerQuotesPath,
  oldQuotePartListPath,
  oldVendorQuotesPath,
  quotePartsPath,
  vendorQuoteListPath,
} from 'quotes/routes/routePaths';

export const BASE_ROUTE = '/v2';

export const routeVersionedMappings = {
  [customerQuoteListPath()]: () => oldCustomerQuotesPath(),
  [vendorQuoteListPath()]: () => oldVendorQuotesPath(),
  [quotePartsPath()]: (quoteId: string, trigger = '') => oldQuotePartListPath(quoteId, trigger),
  [projectDetailsPath()]: (projectId: string) => oldProjectJobListPath(projectId),
};
